<template>
  <Panel>
    <template slot="panel">
      <Breadcrumb :routes="routes"></Breadcrumb>
      <Title title="DIGITAL NPI"></Title>
      <p class="font-20">
        Digital NPI optimizes the often-costly process of getting new products from ideation to market. The product
        verifies the manufacturability of new products to avoid downstream delays, and maps the critical path for moving
        a product from design through manufacturing and quality control.
      </p>
      <p class="font-16">
        <a-icon type="caret-right" :style="iconColor" />
        Automatically manage tasks, resources and responsibilities for individuals and teams, including the external
        supply chain. </p>
      <p class="font-16">
        <a-icon type="caret-right" :style="iconColor" />
        Immediately flag delays and milestone risks for fast decisions.
      </p>
      <p class="font-16">
        <a-icon type="caret-right" :style="iconColor" />
        Quickly share decisions through the digital thread to ensure the project stays on track.
      </p>
      <p class="font-16">
        <a-icon type="caret-right" :style="iconColor" />
        Use learned NPI experience to optimize manufacturing processes and speed mass production of new products.
      </p>
    </template>
  </Panel>
</template>

<script>
import Panel from '@/components/panel'
import Breadcrumb from '@/components/breadcrumb'
import Title from '@/components/title'
export default {
  components: {
    Panel,
    Breadcrumb,
    Title
  },

  data () {
    return {
      routes: [{
        name: this.$root.language.jwisoftware,
        path: '/'
      },
      {
        name: this.$root.language.products,
        path: '/products'
      },
      {
        name: this.$root.language.npi,
        path: '/products/npi'
      }
      ],
      iconColor: {
        color: '#DA4026'
      }
    }
  }
}

</script>
